var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79652 10.5387L4.20907 12.1261C4.08526 12.2499 4.08526 12.4501 4.20907 12.5739C4.27082 12.6356 4.35189 12.6667 4.43296 12.6667C4.51402 12.6667 4.59509 12.6356 4.65684 12.5739L6.24429 10.9864C6.36811 10.8626 6.36811 10.6625 6.24429 10.5387C6.12047 10.4148 5.92002 10.4152 5.79652 10.5387Z",
    fill: "#9777A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76914 10.5387C8.64533 10.4148 8.44519 10.4148 8.32138 10.5387C8.19756 10.6625 8.19756 10.8626 8.32138 10.9864L10.2293 12.8943C10.291 12.9561 10.3721 12.9871 10.4532 12.9871C10.5342 12.9871 10.6153 12.9561 10.6771 12.8943C10.8009 12.7705 10.8009 12.5704 10.6771 12.4466L8.76914 10.5387Z",
    fill: "#9777A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0569 9.59274C15.9331 9.46892 15.733 9.46892 15.6091 9.59274L12.4425 12.7594C12.3187 12.8832 12.3187 13.0834 12.4425 13.2072C12.5042 13.2689 12.5853 13.3 12.6664 13.3C12.7474 13.3 12.8285 13.2689 12.8902 13.2072L16.0569 10.0405C16.1807 9.91669 16.1807 9.71656 16.0569 9.59274Z",
    fill: "#9777A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.950456 19C0.775339 19 0.633789 18.8584 0.633789 18.6833V0.316667C0.633789 0.14155 0.775339 0 0.950456 0C1.12557 0 1.26712 0.14155 1.26712 0.316667V18.6833C1.26712 18.8584 1.12557 19 0.950456 19Z",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6833 18.3666H0.316667C0.14155 18.3666 0 18.2251 0 18.0499C0 17.8748 0.14155 17.7333 0.316667 17.7333H18.6833C18.8584 17.7333 19 17.8748 19 18.0499C19 18.2251 18.8584 18.3666 18.6833 18.3666Z",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 9.18338H2.21706C2.04194 9.18338 1.90039 9.04183 1.90039 8.86672C1.90039 8.6916 2.04194 8.55005 2.21706 8.55005H2.85039C3.02551 8.55005 3.16706 8.6916 3.16706 8.86672C3.16706 9.04183 3.02551 9.18338 2.85039 9.18338Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 7.91666H2.21706C2.04194 7.91666 1.90039 7.77511 1.90039 7.59999C1.90039 7.42488 2.04194 7.28333 2.21706 7.28333H2.85039C3.02551 7.28333 3.16706 7.42488 3.16706 7.59999C3.16706 7.77511 3.02551 7.91666 2.85039 7.91666Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 6.65006H2.21706C2.04194 6.65006 1.90039 6.50851 1.90039 6.33339C1.90039 6.15827 2.04194 6.01672 2.21706 6.01672H2.85039C3.02551 6.01672 3.16706 6.15827 3.16706 6.33339C3.16706 6.50851 3.02551 6.65006 2.85039 6.65006Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 5.38333H2.21706C2.04194 5.38333 1.90039 5.24178 1.90039 5.06667C1.90039 4.89155 2.04194 4.75 2.21706 4.75H2.85039C3.02551 4.75 3.16706 4.89155 3.16706 5.06667C3.16706 5.24178 3.02551 5.38333 2.85039 5.38333Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 4.11661H2.21706C2.04194 4.11661 1.90039 3.97506 1.90039 3.79994C1.90039 3.62483 2.04194 3.48328 2.21706 3.48328H2.85039C3.02551 3.48328 3.16706 3.62483 3.16706 3.79994C3.16706 3.97506 3.02551 4.11661 2.85039 4.11661Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 2.85001H2.21706C2.04194 2.85001 1.90039 2.70846 1.90039 2.53334C1.90039 2.35822 2.04194 2.21667 2.21706 2.21667H2.85039C3.02551 2.21667 3.16706 2.35822 3.16706 2.53334C3.16706 2.70846 3.02551 2.85001 2.85039 2.85001Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85039 1.58328H2.21706C2.04194 1.58328 1.90039 1.44173 1.90039 1.26662C1.90039 1.0915 2.04194 0.949951 2.21706 0.949951H2.85039C3.02551 0.949951 3.16706 1.0915 3.16706 1.26662C3.16706 1.44173 3.02551 1.58328 2.85039 1.58328Z",
    fill: "#BDC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48665 15.1962C4.3611 15.1962 5.06999 14.4873 5.06999 13.6129C5.06999 12.7384 4.3611 12.0295 3.48665 12.0295C2.6122 12.0295 1.90332 12.7384 1.90332 13.6129C1.90332 14.4873 2.6122 15.1962 3.48665 15.1962Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28353 11.3999C8.15798 11.3999 8.86686 10.6911 8.86686 9.81661C8.86686 8.94216 8.15798 8.23328 7.28353 8.23328C6.40908 8.23328 5.7002 8.94216 5.7002 9.81661C5.7002 10.6911 6.40908 11.3999 7.28353 11.3999Z",
    fill: "#71C285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0999 10.45C17.9744 10.45 18.6833 9.74111 18.6833 8.86666C18.6833 7.99221 17.9744 7.28333 17.0999 7.28333C16.2255 7.28333 15.5166 7.99221 15.5166 8.86666C15.5166 9.74111 16.2255 10.45 17.0999 10.45Z",
    fill: "#71C285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3997 15.5166C12.2742 15.5166 12.9831 14.8078 12.9831 13.9333C12.9831 13.0589 12.2742 12.35 11.3997 12.35C10.5253 12.35 9.81641 13.0589 9.81641 13.9333C9.81641 14.8078 10.5253 15.5166 11.3997 15.5166Z",
    fill: "#F29C1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.a692e8550a5c9cf4a2404bee593f5a2d.svg";
export { ForwardRef as ReactComponent };